import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Box, TextField } from '@mui/material';
import { AvatarsCell, AvatarsCellProps } from '..';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
interface AvatarInputProps extends AvatarsCellProps {
  options: any[];
}

export const AvatarsInput = (params: AvatarInputProps) => {
  return (
    <Autocomplete
      multiple
      options={params.options}
      disableCloseOnSelect
      getOptionLabel={option => {
        return option.name;
      }}
      componentsProps={{
        paper: { sx: { width: 200 } },
        // popper: { sx: { width: 200 } },
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.name}
        </li>
      )}
      renderInput={({ inputProps, InputProps }) => {
        return (
          <Box
            ref={InputProps.ref}
            onClick={event => {
              event.stopPropagation();
              (
                InputProps.endAdornment as any
              ).props.children[1].props.onClick();
            }}
            // onMouseDown={inputProps.onMouseDown}
            // onFocus={inputProps.onFocus}
          >
            <TextField
              inputProps={inputProps}
              sx={{ display: 'none', width: 300 }}
            />
            <AvatarsCell {...params} />
          </Box>
        );
      }}
    />
  );
};
